import React from 'react';
import { Link } from 'react-router-dom';
import './CallCenter.css';

export default function CallCenterHomePage() {
  return (
    <div className="call-center-page">
      <h1 className="call-center-title">CallCenter</h1>
      <p className="call-center-subtitle">
        Manage Amazon Connect numbers: view and allocate available numbers, request a new number,
        submit a porting request, and change an allocated number.
      </p>

      <div className="call-center-links">
        <Link className="call-center-link-card" to="/callcenter/numbers">
          <h3>View Available Numbers</h3>
          <p>See numbers returned by AWS Connect and allocate a number to your company.</p>
        </Link>
        <Link className="call-center-link-card" to="/callcenter/request">
          <h3>Request a Number</h3>
          <p>Request or reserve a new number by calling the allocate endpoint.</p>
        </Link>
        <Link className="call-center-link-card" to="/callcenter/port">
          <h3>Port Number</h3>
          <p>Provide your current number details and submit a porting request.</p>
        </Link>
        <Link className="call-center-link-card" to="/callcenter/change">
          <h3>Change Number</h3>
          <p>Replace an already allocated number with a new number.</p>
        </Link>
      </div>
    </div>
  );
}
